import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { useAddNotification } from 'hooks/useAddNotification'
import { patch } from 'utils/http'

export const useCustomerRevealApiConfigPatch = () => {
  const customerId = useCustomerId()
  const addNotification = useAddNotification()
  const queryClient = useQueryClient()

  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (payload: any) => patch(`/management/reveal_api/customers/${customerId}`, payload),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['customer', customerId, 'reveal_api_quota'] })
      addNotification('Reveal API config has been updated')
    },
    onError: () => addNotification('Reveal API config update error', 'error'),
  })

  return {
    patchRevealApiConfig: mutateAsync,
    ...rest,
  }
}
